<template>
  <div>
    <section>
      <div class="left">
        <h2 v-translate>Základní nastavení</h2>
      </div>
      <div class="right">
        <div class="field_left">
          <text-input
              id="sitetitlleurl"
              v-model="entity.liveweb_settings.site_title"
              ref="sitetitleref"
              :disabled="!isEditable"
          >
            <translate class="translate">Titulek webu</translate>
          </text-input>
        </div>
        <text-input
            id="clientzoneurl"
            v-model="entity.liveweb_settings.client_zone_url"
            ref="clientzoneurlref"
            :disabled="!isEditable"
        >
          <translate class="translate">URL klientské zóny</translate>
        </text-input>
        <text-input
            id="logouturl"
            v-model="entity.liveweb_settings.logout_url"
            ref="logouturlref"
            :disabled="!isEditable"
        >
          <translate class="translate">URL po odhlášení</translate>
        </text-input>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Vlastní odkazy</h2>
      </div>
      <div class="right">
        <div class="left">
          <CustomLink
              v-for="(item, key) in entity.liveweb_settings.custom_links"
              :disabled="!isEditable"
              :id="key"
              :key="key + '_' +changeCounter"
              v-model="entity.liveweb_settings.custom_links[key]"
              @deleteCustomLink="onDeleteCustomLink"
          />
        </div>
        <div class="left">
          <div class="field_left">
            <a class="add_period" @click="onAddCustomLink"><translate class="translate">Přidat odkaz</translate></a>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="left">
        <h2 v-translate>Skryté sekce</h2>
      </div>
      <div class="right checkbox_group">
        <ul class="settings">
          <li-checkbox-input
              v-for="hide_section in available_hide_sections"
              :key="hide_section.value"
              :id="'hidden_sections_' + hide_section.value"
              :val="hide_section.value"
              v-model="entity.liveweb_settings.hide_sections"
              :ref="'hidden_sections_' + hide_section.value"
              :disabled="!isEditable"
          >
            {{ hide_section.label }}
          </li-checkbox-input>
        </ul>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Needitovatelná zařízení</h2>
      </div>
      <div class="right checkbox_group">
        <ul class="settings">
          <li-checkbox-input
              :key="device_type.code"
              v-for="device_type in availableDeviceTypes"
              :id="'non_updatable_types' + device_type.code"
              :val="device_type.code"
              v-model="entity.liveweb_settings.non_updatable_device_type_codes"
              :ref="'non_updatable_types' + device_type.code"
              :disabled="!isEditable"
          >
            {{ device_type.name }}
          </li-checkbox-input>
        </ul>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Nesmazatelná zařízení</h2>
      </div>
      <div class="right checkbox_group">
        <ul class="settings">
          <li-checkbox-input
              :key="device_type.code"
              v-for="device_type in availableDeviceTypes"
              :id="'non_deletable_types' + device_type.code"
              :val="device_type.code"
              v-model="entity.liveweb_settings.non_deletable_device_type_codes"
              :ref="'non_deletable_types' + device_type.code"
              :disabled="!isEditable"
          >
            {{ device_type.name }}
          </li-checkbox-input>
        </ul>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Párování a login</h2>
      </div>
      <div class="right">
        <checkbox-input
            id="pairbypairingcode"
            v-model="entity.liveweb_settings.pair_by_pairing_code"
            ref="pairbypairingcode"
            :disabled="!isEditable"
        >
          <translate class="translate">Párování párovacím klíčem</translate>
        </checkbox-input>
        <checkbox-input
            id="automaticpairing"
            v-model="entity.liveweb_settings.automatic_pairing"
            ref="automaticpairingref"
            :disabled="!isEditable"
        >
          <translate class="translate">Automatické párování po přihlášení</translate>
        </checkbox-input>
        <textarea-input
            id="note"
            rows=6
            cols=50
            v-model="entity.liveweb_settings.automatic_pairing_error_message_html"
            :disabled="!isEditable"
        >
          <translate class="translate">Chybová stránka automatického párování (html)</translate>
        </textarea-input>
        <textarea-input
            id="note"
            rows=6
            cols=50
            v-model="entity.liveweb_settings.custom_login_screen_html"
            :disabled="!isEditable"
        >
          <translate class="translate">Doplňkový blok login stránky (html)</translate>
        </textarea-input>
        <textarea-input
            id="note"
            rows=6
            cols=50
            v-model="entity.liveweb_settings.alternative_login_screen_html"
            :disabled="!isEditable"
        >
          <translate class="translate">Alternativní login screen (html)</translate>
        </textarea-input>
      </div>
    </section>
  </div>
</template>

<script>
import CustomLink from "./CustomLink.vue";
import languages from "../../../mixins/languages";

export default {
  name: "LivewebSettings",
  components: {CustomLink},
  mixins: [languages],
  props: {
    isEditable: Boolean,
    entity: Object,
    errorMessages: {
      type: [Array, Object],
      default: function () {
        return []
      },
    },
  },
  created(DeviceTypeService) {
    this.deviceTypeService = DeviceTypeService

    this.initDeviceTypes();
  },
  methods: {
    initDeviceTypes() {
      this.deviceTypeService.getEntitiesForSelectBox().then((deviceTypes) => {
        this.availableDeviceTypes = deviceTypes['device_types']
      });
    },
    onAddCustomLink(){
      this.changeCounter++;
      let titleLanguages = {};
      this.deviceLanguages.forEach(item => {
        titleLanguages[item] = "";
      });

      let voidLink = {
        title: titleLanguages,
        open_in_new_window: false,
        url: "",
        icon: "",
      }
      this.entity.liveweb_settings.custom_links.push(voidLink)
    },
    onDeleteCustomLink(id){
      this.changeCounter++;
      this.entity.liveweb_settings.custom_links = [
          ...this.entity.liveweb_settings.custom_links.slice(0, id),
          ...this.entity.liveweb_settings.custom_links.slice(id+1),
      ];
    }
  },
  data: function() {
    return {
      changeCounter: 0,
      availableDeviceTypes: [],
      available_hide_sections: [
        {
          value: "password",
          label: this.$gettext("Změna hesla")
        },
        {
          value: "devices",
          label: this.$gettext("Správa zařízení")
        },
        {
          value: "add_device",
          label: this.$gettext("Správa zařízení - přidání zařízení")
        },
        {
          value: "devices_channel_groups",
          label: this.$gettext("Správa zařízení - skupiny kanálů")
        },
        {
          value: "channel_groups",
          label: this.$gettext("Skupiny kanálů")
        },
        {
          value: "channel_lock",
          label: this.$gettext("Zamykání kanálů")
        },
        {
          value: "about",
          label: this.$gettext("O aplikaci")
        },
        {
          value: "login_screen",
          label: this.$gettext("Přihlašovací obrazovka")
        },
        {
          value: "dashboard",
          label: this.$gettext("Domů")
        },
        {
          value: "dashboard_settings",
          label: this.$gettext("Nastavení Domů")
        },
        {
          value: "logout",
          label: this.$gettext("Tlačítko odhlášení")
        },
        {
          value: "unlock_icon",
          label: this.$gettext("Tlačítko odemčení")
        },
        {
          value: "password_recovery",
          label: this.$gettext("Obnovení hesla")
        },
        {
          value: "messages",
          label: this.$gettext("Oznámení")
        },
        {
          value: "vod",
          label: this.$gettext('Filmotéka')
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/forms/LivewebSettings.vue